import React, { useEffect } from "react";
import nextId from "react-id-generator";
import { Redirect, Route, useHistory } from "react-router";
import { Link ,withRouter} from "react-router-dom";
import { Images } from "../../../../Assets/0a-exporter";
import CustomSlider from "../../../Common/CustomSlider/CustomSlider";
import PreviewCandidate from "../../../Common/PreviewCandidate/PreviewCandidate";
import ApplicantsTable from "./ApplicantsTable/ApplicantsTable";
import "./job-post-description.style.scss";
import PostDescription from "./PostDescription/PostDescription";
import SmartMatchApplicant from "../../SmartMatchApplicant/SmartMatchApplicant";
import CreateJobPost from "../../CreateJobPost/CreateJobPost";
import JobsCart from "../../JobsCart/JobsCart";
import SuccessJobSummary from "../../SuccessJobSummary/SuccessJobSummary";
import MyTransactions from "../../MyTransactions/MyTransactions";
import { getInstituteJobDetailsById } from "../../../../APIs/GetAPIs";

 const JobPostDescription=(props)=> {
  let job_id=localStorage.getItem("job_id")
  const history = useHistory();
  const [selectedOption, setSelectedOption] = React.useState(options[0]);
  const [openPreview, setOpenPreview] = React.useState(false);
  const [routeTitle, setRouteTitle] = React.useState("");
  const [jobDetails, setJobDetails] = React.useState("");

  const [bar, setBar] = React.useState(true);

  useEffect(()=>{
    const getData=async()=>{
    let ress=await getInstituteJobDetailsById(job_id)
setJobDetails(ress?.data?.data)
    }
    getData()
  },[job_id])
  const handleChange = (obj) => {
    history.push(`/institute/job/${obj.id}`);
    setSelectedOption(obj);
  };
console.log('jobDetails',jobDetails)
{/* <h5 className="job-title">{job?.job_title}</h5>
<p className="institute-name">{job?.institution_name}</p>
<div className="jpcm-info">
  <span>
    <img src={Images.blueBook} />
    {job?.job_curiculum}
  </span>
  <span>
    <img src={Images.groupLogo} />
    {job?.job_class}
  </span>
  <span>
    <img src={Images.suitcaseLogo} />
    {job?.job_type}
  </span>
  <span>
    <img src={Images.manWIthStars} />
    {job?.job_experience} exp
  </span>
  <span>
    <img src={Images.moneyLogo} />
    {job?.job_salary_range}
  </span>
</div> */}

// about_institution: true
// bed_required: false
// createdAt: "2021-10-07T10:39:41.168Z"
// institute_location: true
// institution_id: "615d4d61fd21ddf2c8de355c"
// institution_logo: true
// institution_name: true
// isDraft: false
// job_class: "class 8-10"
// job_college_preference: ['']
// job_curiculum: "cbse"
// job_description: "edwsgefdsgdf"
// job_experience: "4-6yrs"
// job_gender_preference: "none"
// job_id: ""
// job_key_skill: ['']
// job_language_preference: ['']
// job_martinal_status: "unmarried"
// job_outstation_candidate: true
// job_perk_provided: ['']
// job_publish_status: false
// job_role: "teacher"
// job_salary_range: ""
// job_subject: "maths"
// job_title: "test"
// job_type: "Full Time"
// job_vacancies: ""
// salary: true
// status: "active"
// updatedAt: "2021-10-07T10:39:41.168Z"
// __v: 0
// _id: "615ece6d0d2870627d8effd2"
// [[Prototype]]: Ob
  return (
    <div className="job-post-description-main">
      {openPreview && (
        <PreviewCandidate closeIt={() => setOpenPreview(false)} />
      )}
      {bar ? (
        <>
          <header className="jpdm-routes">
            <Link to="/institute">All Jobs</Link>
            <span>{">"}</span>

            {/* <p>PRT Science teacher </p> */}
            <p>{routeTitle} </p>
          </header>
          <div className="jpdm-card">
            <figure>
              <img src={Images.menTree} />
            </figure>
            <figcaption>
              <h5>{jobDetails?.job_title}</h5>
              <p>{jobDetails?.institution_name}</p>
              <div className="jpdmc-more-info">
                <button>Job post expires in : 27 days</button>
                <h6>
                  <img src={Images.eyeLogo} />
                  <span>200 Views</span>
                </h6>
                <h6>
                  <img src={Images.blackSuitCase} />
                  <span>{jobDetails?.job_type}</span>
                </h6>
                <h6>
                  <img src={Images.moneyLogo} />
                  <span>{jobDetails?.job_salary_range!==undefined&& 
                  jobDetails.job_salary_range.replace(/[^a-zA-Z0-9]/g,'-').substring(1,jobDetails.job_salary_range.replace(/[^a-zA-Z0-9]/g,'-')
.length-1)
                  }
                  </span>
                </h6>

                <h6>
                  <img src={Images.manWIthStars} />
                  <span>{jobDetails?.job_experience} </span>
                </h6>
              </div>
            </figcaption>
          </div>
          <div className="jpdm-slider">
            <CustomSlider
              list={options}
              selectedOption={selectedOption}
              setSelectedOption={handleChange}
            />
          </div>
        </>
      ) : (
        ""
      )}

      <switch>
        <Route
          exact
          path="/institute/job/appointments"
          render={() => (
            <ApplicantsTable
              setOpenPreview={setOpenPreview}
              setRouteTitle={setRouteTitle}
            />
          )}
        />
        <Route
          exact
          path="/institute/job/smartmatch"
          render={() => <SmartMatchApplicant setRouteTitle={setRouteTitle} />}
        />
        <Route
          exact
          path="/institute/job/description"
          render={() => (
            <PostDescription
              setRouteTitle={setRouteTitle}
              initialRun={() => setSelectedOption(options[1])}
            />
          )}
        />
        <Route
          exact
          path="/institute/job/createjobpost"
          render={() => (
            <CreateJobPost
              setRouteTitle={setRouteTitle}
              disableInitial={setBar}
            />
          )}
        />
        <Route
          exact
          path="/institute/job/createjobpost/cart"
          render={() => (
            <JobsCart setRouteTitle={setRouteTitle} disableInitial={setBar} />
          )}
        />
        <Route
          exact
          path="/institute/job/createjobpost/cart/orderplaces"
          render={() => (
            <SuccessJobSummary
              setRouteTitle={setRouteTitle}
              disableInitial={setBar}
            />
          )}
        />
        <Route
          exact
          path="/institute/job/createjobpost/myTransactions"
          render={() => (
            <MyTransactions
              setRouteTitle={setRouteTitle}
              disableInitial={setBar}
            />
          )}
        />
        {/* <Redirect to={`/institute/job/${selectedOption.id}`} /> */}
      </switch>
    </div>
  );
}
export default withRouter(JobPostDescription)

const options = [
  { keyId: nextId(), id: "appointments", text: "View Applicants" },
  { keyId: nextId(), id: "description", text: "Job Description" },
];
